import { MarketIdentifier } from '~/app/market-config/models/market-identifier';

export const DEFAULT_MARKET_LANGUAGES: Record<MarketIdentifier, string> = {
	DE: 'de',
	NO: 'no',
	ES: 'es',
	IT: 'it',
	GB: 'en',
	PL: 'pl',
	IN: 'en',
	GR: 'el',
	FR: 'fr',
	US: 'en',
	ME: 'en',
	MX: 'es',
	NL: 'nl',
	IE: 'en',
	DK: 'da',
	SE: 'sv',
	BE: 'fr',
	FI: 'fi',
	LU: 'de',
	CH: 'de',
	AU: 'en',
	SG: 'en',
	SM: 'en',
	CA: 'en',
	TR: 'tr',
	AR: 'es',
	BR: 'pt',
	KR: 'ko',
	JP: 'ja',
	TW: 'zh',
	ZA: 'en',
	AZ: 'en',
	BH: 'en',
	DU: 'en',
	SA: 'en',
	KW: 'en',
	OM: 'en',
	QA: 'en',
	JO: 'en',
	LB: 'en',
};
